import { buildGumletUrl, GUMLET_PRESETS } from '@/utils/gumlet';
import { resolveStorefrontImage } from '@/utils/resolve-storefront-image';

/** Matches the 16/10 hero capped at 520px (~832px wide) and full-width mobile. */
export const RECIPE_HERO_LCP_IMAGE_SIZES = '(min-width: 56rem) 832px, 100vw';

const RECIPE_HERO_SRCSET_WIDTHS = [800, 1280] as const;

export type RecipeHeroLcpImage = {
  src: string;
  srcSet?: string;
  sizes: string;
};

/**
 * Gumlet variants for the recipe detail LCP image. Preload `src` / `srcSet` /
 * `sizes` must match the `<img>` exactly or the preload is wasted.
 */
export const getRecipeHeroLcpImage = (src: unknown): RecipeHeroLcpImage => {
  const resolved = resolveStorefrontImage(src, undefined, GUMLET_PRESETS.recipeHero);
  const raw = typeof src === 'string' ? src.trim() : '';

  if (!raw || resolved.startsWith('/imgs/')) {
    return { src: resolved, sizes: RECIPE_HERO_LCP_IMAGE_SIZES };
  }

  const srcSet = RECIPE_HERO_SRCSET_WIDTHS.map(width => {
    const href = buildGumletUrl(raw, { width, quality: GUMLET_PRESETS.recipeHero.quality });
    return `${href} ${width}w`;
  }).join(', ');

  return {
    src: resolved,
    srcSet,
    sizes: RECIPE_HERO_LCP_IMAGE_SIZES,
  };
};
